import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Prompt from '../Prompt';
import DialogPrompt from '../DialogPrompt';
import BadgeCollect from '../../badges/BadgeCollect';
import Option from './SingleAnswerOptionReview'; //eslint-disable-line import/no-named-as-default
import * as userDataHelper from '../../../../helpers/userDataHelper';
import * as localStorage from '../../../../localStorage/localStorage';
import * as appDataActions from '../../../../actions/appDataActions';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as dialogPopupActions from '../../../../actions/dialogPopupActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class SingleAnswerReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            locale: appHelper.getLocalData(this.props.screenObject),
            userData: this.props.userData,
            objectStates: objectConstants.OBJECT_DISPLAY_STATES,
            responseData: this.props.responseData,
            feedbackData:this.props.responseData.latestResponse,
            showOptions: true,
            showFeedback: true,
            selectedOption: "",
            //badges
            badgesEarned:[],
            checkBadgesEarned: false,
            collected: true,
            character_name: appHelper.isDefined(this.props.callbacks) ? this.props.callbacks.getCharacterName() : appHelper.getScreenCharacterNameByAssetId(this.props.screenObject.asset_id),
        };
        this.onOptionClick = this.onOptionClick.bind(this);
        this.renderFeedback = this.renderFeedback.bind(this);
        this.renderOptions = this.renderOptions.bind(this);
        //badges
        this.checkBadgeEarnedOnObject = this.checkBadgeEarnedOnObject.bind(this);
        this.getBadge = this.getBadge.bind(this);
    }

    componentDidMount() {
        this.checkBadgeEarnedOnObject();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({
                userData: Object.assign({}, nextProps.userData),
                checkBadgesEarned: true
            });
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject)
            });
        }
    }

    componentDidUpdate(){
        if(!this.state.showFeedback){
            this.renderFeedback();
        }
        if(this.checkBadgesEarned){
            this.checkBadgeEarnedOnObject();
        }
    }

    checkBadgeEarnedOnObject(){
        let params = {
            bite_id: this.state.responseData.bite_id,
            asset_id: this.state.screenObject.asset_id
        };

        let badgesEarned = userDataHelper.checkBadgeEarnedOnObject(this.state.userData, params);
        this.setState({
            checkBadgesEarned: false,
            badgesEarned: Object.assign([],badgesEarned)
        });
    }

    getBadge(badge_id){
        //return appHelper.getArrayObjectByKey(localStorage.achievements, "code", code);
    }

    renderFeedback(){
        this.setState({showFeedback: true});
    }


    onOptionClick(option) {
        this.setState(
            {
                feedbackData: Object.assign({}, option),
                showFeedback: false
            }
        );
    }

    renderOptions(){}

    render() {
        return (

            <div className="learner-action">
                {
                    this.state.badgesEarned.length > 0
                        ?
                        <div>
                            {this.state.badgesEarned.map(badge =>
                                <BadgeCollect key={badge.badge_id} badge_id={badge.badge_id} bite_id={this.state.responseData.bite_id} asset_id={this.state.responseData.asset_id} collected={this.state.collected}/>
                            )} <br/>
                        </div>
                        : null
                }

                {this.state.screenObject.prompt_type === objectConstants.PROMPT_TYPE_DIALOG_PROMPT
                    ?
                    <div className="object-container">
                        <DialogPrompt character_name={this.state.character_name} id={this.state.screenObject.asset_id}
                                  locale={this.state.locale} show_title={this.state.screenObject.show_title}
                                  onComplete={this.renderOptions}/>
                    </div>
                    :
                    <div className="horz-padding">
                        <Prompt id={this.state.screenObject.asset_id} locale={this.state.locale}
                            show_title={this.state.screenObject.show_title} onComplete={this.renderOptions}/>
                    </div>
                }

                <div className="multiple-choice-option-list">
                    {this.state.screenObject.options.map(option =>
                        <Option key={option.option_id} option={option}
                                                    options={this.state.screenObject.options}
                                                    asset_id={this.state.screenObject.asset_id}
                                                    responseData={this.state.responseData}
                                                    onOptionClick={this.onOptionClick}
                                                    optionReviewId={this.state.feedbackData.option_id}

                        />
                    )}
                </div>
            </div>
        );
    }
}

SingleAnswerReview.propTypes = {
    screenObject: PropTypes.object.isRequired,
    responseData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    callbacks: PropTypes.object
};

SingleAnswerReview.contextTypes = {
    router: PropTypes.object
};


function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions, dialogPopupActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SingleAnswerReview);




/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/singleAnswer/SingleAnswerReview.js
 **/